import { createContext, useContext } from 'react';

const FormContext = createContext();

function useFormContext() {
  return useContext(FormContext);
}

export default FormContext;
export { useFormContext };
